<template>
    <el-dialog  title="选择地址"  :close-on-click-modal="false"  append-to-body :close-on-press-escape="false"  @close="closeDialog" :visible.sync="dialogXzdz" width="1100px" center>
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="地址:" prop="address">
                <el-input  placeholder="" v-model="searchFrom.address"></el-input>
              </el-form-item>
              <el-form-item label="单位名称:" prop="company">
                <el-input  placeholder="" v-model="searchFrom.company"></el-input>
              </el-form-item>
              <el-form-item label="联系人:" prop="person">
                <el-input  placeholder="" v-model="searchFrom.person"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="phone">
                <el-input  placeholder="" v-model="searchFrom.phone"></el-input>
              </el-form-item>
              <el-form-item label="省市区:" class="diqu">
                <shengShiXian @handleChange="handleChange" :rowData="this.searchFrom" v-if="isShowAddressInfo"></shengShiXian>
              </el-form-item>
              <el-form-item>
              </el-form-item>
              <el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
            </div>
        </div>
      </el-form>
      <el-table :data="xzdz" ref="xzdz" highlight-current-row  @current-change="handleCurrentChange" @row-dblclick="dbSelected">
        <el-table-column fixed type="index" width="55" height="450px" label="序号"></el-table-column>
        <el-table-column prop="company" label="单位名称"></el-table-column>
        <el-table-column prop="person" width="130" label="联系人"></el-table-column>
        <el-table-column prop="phone" width="130" label="联系电话"></el-table-column>
        <el-table-column prop="name" label="地址"></el-table-column>
        <!-- <el-table-column property="type" width="120" label="地址类型" >
          <template scope="scope">
            {{[ "收货地址", "发货地址" ][scope.row.type-1]}}
          </template>
        </el-table-column> -->
      </el-table>
       <!-- 分页 -->
      <div>
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[50,100,200,1000]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogXzdz = false">取 消</el-button>
        <el-button type="primary" @click="xzdzFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import { sAddressList } from '@/api/soc-stock'
import shengShiXian from '@/components/common/shengShiXian.vue'
export default {
  name: 'selectAddress',
  props: ['type', 'tenantId'],
  components: {
    shengShiXian
  },
  data () {
    return {
      dialogXzdz: false,
      currentRow: null,
      xzdz: [],
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      isShowAddressInfo: true
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialogXzdz = true
    if (this.tenantId) {
      this.searchFrom.tenantId = this.tenantId
    }
    this.searchFrom.type = this.type
    this.getAddress()
  },
  methods: {
    // 地区选中
    handleChange (value) {
      if (value) {
        this.searchFrom.provinceCode = value[0].areaCode
        this.searchFrom.cityCode = value[1].areaCode
        this.searchFrom.areaCode = value[2].areaCode
      }
    },
    // 双击行
    dbSelected (row) {
      this.xzdzFn()
    },
    handleCurrentChange (val) {
      this.currentRow = val
    },
    xzdzFn () {
      if (this.currentRow == null) {
        this.$alert('请选择一条地址', '系统提示')
      } else {
        this.$emit('handleCurrentChange', this.currentRow)
      }
    },
    // 获取地址
    getAddress () {
      sAddressList(this.searchFrom).then(res => {
        this.xzdz = res.list
        this.total = res.total
      })
    },
    // 查选
    searchFn () {
      this.getAddress(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getAddress(this.searchFrom)
    },
    // 当前页
    handleCurrentChange1 (val) {
      this.searchFrom.pageNo = val
      this.getAddress(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null,
        type: this.type
      }
      this.isShowAddressInfo = false
      // 这里搞个定时器重新载入一下组件就可以触发组件拉取数据
      setTimeout(() => {
        this.isShowAddressInfo = true
      }, 0)
    },
    closeDialog () {
      this.$emit('destroy')
      this.derverFrom = {
        pageNo: 1,
        pageSize: 50
      }
    }

  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-table .warning-row {
    background: #c4fbd2!important;
  }
</style>
